import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var StudentMetrics = require("lib/data/StudentMetrics");
var Spinner = require("components/utility/Spinner");

var ProgressDisplay = require('components/users/students/ProgressDisplay');
var DateSpanSelector = require("components/data/DateSpanSelector");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

require("users/students/student_expectations_display.scss");

@connect(
	(state, props) => ({
		student: RosterSelectors.student({ state, id: props.studentID }),
		loadingStudent: RosterSelectors.isLoadingStudents({ state, key: props.studentID })
	}),
	(dispatch, props) => ({
		populateData: (startDate, endDate) => {
			var query = {};
			if (startDate) {
				query.expectations_progress_start_date = startDate;
			}
			if (endDate) {
				query.expectations_progress_end_date = endDate;
			}

			return dispatch(RosterActions.fetchStudent({
				id: props.studentID, query,
				embeds: ["student.expectations_progress", "student.prefs", "student.expectations_date_spans"]
			}))
		}
	})
)
@providePopulateData()
class StudentExpectationsDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			startDate: null, endDate: null
		};
	}

	startDate() {
		var dateSpans = this.props.student.expectations_date_spans;
		return this.state.startDate || dateSpans[0].start
	}
	endDate() {
		var dateSpans = this.props.student.expectations_date_spans;
		return this.state.endDate || dateSpans[0].end
	}

	changeDates(startDate, endDate) {
		this.setState({ startDate, endDate }, () => {
			this.props.populateData(startDate, endDate)
		});
	}

	isMatchingDateSpan() {
		if (this.props.student && this.props.student.expectations_date_spans) {
			return _.filter(this.props.student.expectations_date_spans, (span) => {
				return (span.start == this.startDate()) && (span.end == this.endDate());
			}).length > 0;
		}
		return false
	}

	renderDateSelectors() {
		if (this.props.student && this.props.student.expectations_date_spans) {
			var dateSpans = this.props.student.expectations_date_spans;
			return (
				<div className="dateSpanSelectorWrap">
					<DateSpanSelector startDate={ this.startDate() } endDate={ this.endDate() }
						expectationsSpans={ dateSpans }
						onSelectDates={ this.changeDates } />
				</div>
			);			
		}
	}

	render() {
		var student = this.props.student;

		if (this.props.loadingStudent || !student || !student.prefs || 
			!student.expectations_progress || !student.expectations_date_spans) {

			var progressDisplay = (
				<div>
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			);
		} else if (this.isMatchingDateSpan()) {
			var grade_level = student && student.grade_level ? parseInt(student.grade_level) : 5
			var expectations = student.prefs.grade_level_expectations_metrics[grade_level]
			var progress = student.expectations_progress;

			var progressDisplay = _.map(expectations, (expectation) => {
				var metric = expectation.metric;

				if (this.props.onActionClick) {
					var onActionClick = this.props.onActionClick.bind(this, StudentMetrics.getAction(metric), null);
				}

				return (
					<ProgressDisplay key={ metric }
						title={ StudentMetrics.getLabel(metric) }
						unit={ StudentMetrics.getUnit(metric) }
						total={ expectation.goal }
						current={ progress[metric] }
						actionLabel={ StudentMetrics.getActionLabel(metric) }
						onActionClick={ onActionClick } />
				);
			});
		} else {
			var progress = student.expectations_progress;
			var progressDisplay = _.map(progress, (amount, metric) => {
				return (
					<span className="singleStat" key={ metric }>
						<span className="metric">{ StudentMetrics.getLabel(metric) }</span><br />
						<span className="amount">{ amount }</span>
					</span>
				);
			});
		}

		return (
			<div className="studentExpectationsDisplay">
				{ this.renderDateSelectors() }
				{ progressDisplay }
			</div>
		);
	}
};

StudentExpectationsDisplay.WrappedComponent.propTypes = StrictPropTypes({
	studentID: PropTypes.number.isRequired,
	onActionClick: PropTypes.func,

	// From @connect
	student: PropTypes.object,
	populateData: PropTypes.func,
	loadingStudent: PropTypes.bool
});

module.exports = StudentExpectationsDisplay;



// WEBPACK FOOTER //
// ./modules/components/users/students/StudentExpectationsDisplay.js